import { createFileRoute, redirect } from '@tanstack/react-router'
import { MainLayout } from '../components/MainLayout'
import { AccountsBrowserPage } from '../pages/AccountsBrowserPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/accounts-browser' as any)({
  component: () => (
    <MainLayout>
      <AccountsBrowserPage />
    </MainLayout>
  ),
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) throw redirect({ to: '/login' })
  },
})
